module.exports = __webpack_public_path__ + "static/media/Genera-AltLight.7b029766.ttf";